import React from "react";
// import video from '../media/gradient.mp4'

export const Landing = () => {
  return (
    <>
      <section className="landing">
        <div className="_wrapperLanding">
          <div className="_text">
            <div className="_textI">
              <div className="vidHouse">
                <h1>Software</h1>

                <h1>
                  Engineer<span>.</span>
                </h1>
              </div>

              <p>
                I like to craft solid and scalable frontend products with great
                user experiences.
              </p>
            </div>

            <div className="_paraG">
              <p className="h1BG">
                Highly skilled at progressive enhancement, programming languages
                , design systems &amp; Technical writing.
              </p>

              <p className="h1BG">
                Over 5 years of experience building very scalabe products
                for clients across africa.
              </p>
            </div>
            {/* <div>
              <div className="_row">
                <a
                  href="https://drive.google.com/file/d/1G0RSQk8mefABr4hphF4TNJ8M5s9FwiiN/view"
                  className="landing-btn"
                >
                
                  See My Résumé
                </a>
              </div>
            </div> */}

            <div className="_capture">
              <div>
                <a
                  href="https://docs.google.com/document/d/1pgDkPY8g54oGiydfTjO5Fp5GQQZFeS75gHNh2Zs9DBg/edit?usp=sharing"
                  target="_blank"
                  rel="noreferrer noopener "
                  className="_aCapture seeresume"
                >
                  See My CV / Résumé
                  <span></span>
                </a>
              </div>
            </div>
          </div>

          <div className="_imageH">
          
            <div>
              <span className="fineBoy">
                
                {/* <div className="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 landing-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
                    />
                  </svg>
                </div> */}
                {/* <div className="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 landing-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
                    />
                  </svg>
                </div> */}
                {/* <div className="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 landing-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
                    />
                  </svg>
                </div> */}
              </span>
            </div>
           
          </div>
        </div>
      </section>
    </>
  );
};
